import { fromJS } from 'immutable';
import { get } from 'lodash';
import { SET_REJECTED_CLAIMS } from 'containers/ManagerRejectedClaimsPage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';
import { SET_SEARCH } from 'containers/ValidatedClaimsPage/constants';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const rejectedClaimsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_REJECTED_CLAIMS:
      return state
        .set('claims', fromJS(action.response.claims))
        .set('countClaims', fromJS(action.response.total));
    case SET_SEARCH:
      return state
        .set('claims', fromJS(action.data))
        .set('countClaims', fromJS(get(action, 'data', []).length));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default rejectedClaimsReducer;
